import componentShell from "./shell"
import HelpCenter from "@/help_center/components/help_center"

export default componentShell(HelpCenter)
